/**
 * The embeddable widgets (`/embed/*`, e.g. `/embed/f10-checker` and
 * `/embed/rams-generator`) are framed by OTHER sites (`frame-ancestors *`
 * via next.config.ts). They load no analytics or advertising tags:
 *
 *  - GA4, Microsoft Clarity and Microsoft UET are suppressed on `/embed` by
 *    `lib/analytics/signed-url-surfaces.ts` (`SIGNED_URL_SURFACE_PREFIXES`);
 *  - PostHog and the Meta Pixel are mounted only by route-group layouts
 *    (`app/(marketing)`, `app/(funnel)`, …), and `/embed` sits outside every
 *    route group with no layout of its own.
 *
 * With nothing to consent to, the cookie banner and the "Cookie preferences"
 * footer control are hidden there (Alec's decision, 27 Oct 2026): in a small
 * iframe the banner covered the lower half of the widget. Both root-layout
 * consent controls read this one predicate.
 *
 * Pinned by `__tests__/analytics/embed-no-consent-banner.test.tsx`, which
 * also re-proves the no-analytics premise so the banner cannot be hidden on a
 * surface that starts loading a tag.
 */
export const EMBED_PATH_PREFIX = "/embed";

export function isEmbedPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return (
    pathname === EMBED_PATH_PREFIX ||
    pathname.startsWith(`${EMBED_PATH_PREFIX}/`)
  );
}
